import React, {useEffect, useState} from "react";
import {BodyDropDown, ItemStyled} from "../../../styles/ContentViews";
import {LoadComponet} from "../../../components/loaders/Loader";
import Table from "../../../components/table/Tables";
import DeleteModal from "../../../components/modals/DeleteModal";
import ShowApplicantModal from "./ShowModal";
import {HistoryListUsers} from "../../../services/CoursesServices";

export default function ApplicantsTable({theme}) {
   const [isLoading, setIsLoading] = useState({data: true, view: false});
   const [data, setData] = useState([]);
   const [showApplicant, setShowApplicant] = useState({isOpen: false, data: {}});
   const [deleteApplicant, setDeleteApplicant] = useState({isOpen: false, id: "", url: ""});

   useEffect(() => {
      getData();
   }, []);

   const getData = () => {
      HistoryListUsers(3)
         .then((res) => res.json())
         .then((resp) => {
            const {status, data} = resp;
            if (status === "error") throw new Error();
            setData(data);
         })
         .then(() => {
            setIsLoading({data: false, view: false});
         })
         .catch((e) => {
            setData([]);
            setIsLoading({data: false, view: false});
            console.log(e);
         });
   };

   const removeId = (id) => {
      if (!IDBCursor) return false;
      let newAdminList = data.filter((item) => item.id !== id);
      setData(newAdminList);
      setDeleteApplicant({isOpen: false, id: "", url: ""});
   };

   return (
      <>
         <BodyDropDown>
            <ItemStyled>
               {isLoading.data ? (
                  <LoadComponet isVisible={true} theme={theme} />
               ) : (
                  <Table 
                  noDataText="No hay usuarios registrados para "
                     data={data}
                     columns={Columns}
                     theme={theme}
                     showModal={(id) => setShowApplicant({isOpen: true, data: data.find((item) => item.id === id)})}
                     deleteModal={(id) => setDeleteApplicant({isOpen: true, id: id, url: "http://freeticket.trebolbit.com/api/city/list"})}
                  />
               )}
            </ItemStyled>
         </BodyDropDown>
         <ShowApplicantModal
            isOpen={showApplicant.isOpen}
            close={() => {
               setShowApplicant({isOpen: false, data: []});
            }}
            data={showApplicant.data}
            theme={theme}
         />
         <DeleteModal
            isOpen={deleteApplicant.isOpen}
            id={deleteApplicant.id}
            url={deleteApplicant.url}
            close={() => {
               setDeleteApplicant({isOpen: false, id: "", url: ""});
            }}
            theme={theme}
            save={removeId}
         />
      </>
   );
}

const Columns = [
   {
      title: "Nombre",
      accessor: "name",
      action: "show",
   },
   {
      title: "empresa",
      accessor: "workplace",
   },
   {
      title: "interés",
      accessor: "shortDescription",
      width: "250px",
   },
   {
      title: "email",
      accessor: "email",
      // maxWidth: "180px",
   },
];

const DataApplicants = [
   {
      id: 0,
      name: "Saundra",
      subject: "in cillum",
      company: "Virva",
      email: "saundraneal@virva.com",
      phone: "(816) 578-2919",
      date: "Mon Feb 03 2020 14:18:13 GMT-0600 (hora estándar central)",
   },
   {
      id: 1,
      name: "Terrell",
      subject: "deserunt veniam ullamco",
      company: "Imkan",
      email: "terrellneal@imkan.com",
      phone: "(910) 468-3194",
      date: "Fri Feb 07 2020 22:52:54 GMT-0600 (hora estándar central)",
   },
   {
      id: 2,
      name: "Hickman",
      subject: "enim exercitation",
      company: "Quarmony",
      email: "hickmanneal@quarmony.com",
      phone: "(812) 426-3927",
      date: "Mon Mar 02 2020 20:58:16 GMT-0600 (hora estándar central)",
   },
   {
      id: 3,
      name: "Graves",
      subject: "nostrud nostrud",
      company: "Greeker",
      email: "gravesneal@greeker.com",
      phone: "(820) 436-2933",
      date: "Thu Jan 23 2020 05:51:29 GMT-0600 (hora estándar central)",
   },
   {
      id: 4,
      name: "Frieda",
      subject: "enim officia aliqua",
      company: "Waterbaby",
      email: "friedaneal@waterbaby.com",
      phone: "(839) 488-3932",
      date: "Tue Feb 18 2020 11:45:40 GMT-0600 (hora estándar central)",
   },
   {
      id: 5,
      name: "Kathryn",
      subject: "eiusmod id incididunt",
      company: "Plasto",
      email: "kathrynneal@plasto.com",
      phone: "(900) 510-3040",
      date: "Thu Jan 23 2020 03:00:12 GMT-0600 (hora estándar central)",
   },
   {
      id: 6,
      name: "Maggie",
      subject: "magna",
      company: "Opticall",
      email: "maggieneal@opticall.com",
      phone: "(981) 576-3330",
      date: "Wed Feb 26 2020 09:16:22 GMT-0600 (hora estándar central)",
   },
   {
      id: 7,
      name: "Stone",
      subject: "nostrud",
      company: "Zoinage",
      email: "stoneneal@zoinage.com",
      phone: "(811) 456-2294",
      date: "Wed Jan 22 2020 21:42:19 GMT-0600 (hora estándar central)",
   },
   {
      id: 8,
      name: "Arline",
      subject: "enim et ut",
      company: "Realysis",
      email: "arlineneal@realysis.com",
      phone: "(822) 492-2958",
      date: "Sun Feb 16 2020 04:04:05 GMT-0600 (hora estándar central)",
   },
   {
      id: 9,
      name: "Stanton",
      subject: "labore",
      company: "Pharmacon",
      email: "stantonneal@pharmacon.com",
      phone: "(894) 568-3013",
      date: "Wed Mar 11 2020 05:01:44 GMT-0600 (hora estándar central)",
   },
];
